import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import { collapseToast, toast } from 'react-toastify';
import { ApiManager } from '../../../core/api-manager';
import ModalEntityCompiler from '../../../components/Modals/ModalEntityCompiler';
import { LoginManager } from '../../../core/login-manager';
import { prepareSupplierDdtTemplateData } from '../../utils/prepareTemplateData';
import PrintDocxButton from '../../utils/PrintDocxButton';




export default function DGLTH_ddt_supplier({ item, entity = null, refreshData }) {

    const navigate = useNavigate();
    const userInfo = LoginManager.getUserInfo();


    const [loadingUnloadAll, setLoadingUnloadAll] = useState(false);
    const [arrayErrors, setArrayErrors] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);

    const [modalCompilerStatus, setModalCompilerStatus] = useState(false)
    const [modalCompilerInitData, setModalCompilerInitData] = useState(null)
    function closeModalCompiler() {
        setModalCompilerStatus(false);
    }

    async function openModalCompiler() {
        var res = await DataManager.getItem('supplier_transport_document', item.id);
        if (res.success === 1 && res.body.length > 0) {
            setModalCompilerInitData(res.body[0])
            setModalCompilerStatus(true);
        }
    }

    async function modalCompilerSave(el) {
        console.log('el', el, modalCompilerInitData)

        // update
        var response = await DataManager.updateItem('supplier_transport_document', el, modalCompilerInitData.id);
        if (response.success === 1) {
            handleConfirmSupplierOrder();
            refreshData()
        }
        else {
            console.warn(response);
        }
        setModalCompilerInitData(null);
        closeModalCompiler();
    }

    async function handleConfirmSupplierOrder() {
        var response = await DataManager.updateItem('supplier_transport_document', {
            status: { value: '5_READY' }
        }, item.id)
        if (response.success === 1) {
            refreshData()
        }
    }

    function sendEmail() {
        navigate('/page/SendDocumentEmailSupplierDDT?id=' + item.id + '&e=supplier_transport_document')
    }

    async function loadPrintData() {
        var response = await DataManager.getItem('supplier_transport_document', item.id);
        if (response.success !== 1) return null;
        var v = response.body[0];

        // Raggruppa righe per idItemModel (somma quantità)
        var groupedRows = v.rows.reduce((acc, cur) => {
            const existingItem = acc.find(r => r.idItemModel?.id === cur.idItemModel?.id);
            if (existingItem) {
                existingItem.quantity += cur.quantity;
            } else {
                acc.push({ ...cur });
            }
            return acc;
        }, []);
        v.rows = groupedRows;

        let rifOrder = '';
        let address = '';
        if (v.idSupplierOrder) {
            var res = await DataManager.getItem('supplier_order', v.idSupplierOrder);
            if (res.success === 1) {
                rifOrder = res.body[0].internalCode;
                address = res.body[0].address?.address || '';
            }
        }

        return {
            fileDocument: v.fileDocument,
            templateData: prepareSupplierDdtTemplateData(v, rifOrder, address),
            filename: 'ddt_fornitore_' + v.internalCode,
            entity: 'supplier_transport_document',
            id: item.id
        };
    }


    async function unloadAll() {
        if (loadingUnloadAll) return;
        setLoadingUnloadAll(true);
        setArrayErrors([]);
        var res = await DataManager.getItem('supplier_transport_document', item.id);
        try {
            if (res.success === 1 && res.body && res.body.length > 0) {
                console.log(res)
                var body = res.body[0];
                var temp = [];

                for (let i = 0; i < body.rows.length; i++) {
                    temp.push({ 'idSupplierTransportDocumentRow': body.rows[i]?.id, 'idItemModel': body.rows[i]?.idItemModel?.id, 'quantity': parseInt(body.rows[i]?.quantity) })
                }

                var payload = {
                    rows: temp,
                    idMovementScope: 0,
                    numberDocument: body.internalCode,
                    idWarehouseFinish: body.idWarehouseFinish?.id
                }
                var r = await ApiManager.sendAuthenticatedRequest('/custom/unload_supplier_ddt', payload);

                if (r.errors && Array.isArray(r.errors) && r.errors.length > 0) {
                    setArrayErrors(r.errors);
                    setShowErrorModal(true);
                }

                if (r.success === 1 && (!r.errors || !Array.isArray(r.errors) || r.errors.length === 0)) {
                    toast.success('Quantità scaricata con successo', { theme: 'colored' });
                    await refreshData();
                } else if (r.success !== 1 && (!r.errors || !Array.isArray(r.errors) || r.errors.length === 0)) {
                    toast.error(r.message || 'Errore durante lo scarico DDT fornitore', { theme: 'colored' });
                }
            } else {
                toast.error(res.message || 'Errore nel recupero del DDT fornitore', { theme: 'colored' });
            }
        } catch (e) {
            console.error(e);
            toast.error('Errore imprevisto durante lo scarico DDT fornitore', { theme: 'colored' });
        } finally {
            setLoadingUnloadAll(false);
        }
    }

    return (
        <>




            {parseInt(userInfo?.level) !== 3 ? <>
                {item.status.value === '0_PENDING' ? (
                    <Button
                        onClick={openModalCompiler}
                        className='me-1'
                        variant='success'
                        size='sm'
                    >
                        <FontAwesomeIcon icon={'circle-check'} className='me-1' />
                        Conferma
                    </Button>
                ) : (
                    <>
                        {/* {item.status.value === '5_READY' ? <Button size='sm' variant="success" className='me-1' onClick={() => navigate('/page/UnloadDDTSupplier?id=' + item.id)}>Scarica merce</Button> : null} */}
                        {item.status.value === '5_READY' ? (
                            <Button
                                size='sm'
                                variant="success"
                                className='me-1'
                                onClick={() => unloadAll()}
                                disabled={loadingUnloadAll}
                            >
                                {loadingUnloadAll ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                                Scarica merce
                            </Button>
                        ) : null}

                        <Button
                            variant='secondary'
                            size='sm'
                            className='me-1'
                            onClick={() => { navigate('/page/BindellaSupplierDDT?id=' + item.id) }}
                        >
                            Bindelle
                        </Button>
                        <PrintDocxButton
                            templateKey="template_ddt_supplier"
                            loadData={loadPrintData}
                            buttonLabel=""
                            className="me-1"
                            icon="print"
                        />
                        <Button
                            size='sm'
                            variant='outline-primary'
                            onClick={() => { sendEmail() }}
                        >
                            <FontAwesomeIcon icon={'envelope'} />
                        </Button>
                    </>
                )}
            </> : <>
                <div className='d-flex flex-column me-2' style={{ gap: '0.25rem' }}>
                    {item.status.value === '5_READY' ? (
                        <Button
                            size='sm'
                            variant="success"
                            className='me-1'
                            onClick={() => unloadAll()}
                            disabled={loadingUnloadAll}
                        >
                            {loadingUnloadAll ? <Spinner animation="border" size="sm" className='me-1' /> : null}
                            Scarica merce
                        </Button>
                    ) : null}

                    <Button
                        variant='secondary'
                        size='sm'
                        className='me-1'
                        onClick={() => { navigate('/page/BindellaSupplierDDT?id=' + item.id) }}
                    >
                        Bindelle
                    </Button>
                </div>
            </>}

















            <ModalEntityCompiler entity={'supplier_transport_document'} initData={modalCompilerInitData} close={closeModalCompiler} status={modalCompilerStatus} confirmCallback={modalCompilerSave} />

            <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} scrollable size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Errori scarico DDT fornitore</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {arrayErrors && arrayErrors.length > 0 ? (
                        arrayErrors.map((err, i) => (
                            <Alert key={i} variant='danger' className='mt-2'>
                                {err.message ? <p className='mb-0'>Messaggio: <b>{err.message}</b></p> : null}
                                {err.codeFather ? <p className='mb-0'>Codice articolo padre: <b>{err.codeFather}</b></p> : null}
                                {err.code ? <p className='mb-0'>Codice articolo figlio: <b>{err.code}</b></p> : null}
                                {err.quantity !== undefined && err.quantity !== null ? <p className='mb-0'>Quantità necessaria: <b>{err.quantity}</b></p> : null}
                                {err.quantityWarehouse !== undefined && err.quantityWarehouse !== null ? <p className='mb-0'>Quantità magazzino: <b>{err.quantityWarehouse}</b></p> : null}
                            </Alert>
                        ))
                    ) : (
                        <p>Nessun dettaglio errore disponibile.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={() => setShowErrorModal(false)}>
                        Chiudi
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};
